// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type {
  ChannelMetadata,
  ChannelTextLocalization,
  Tag,
  TagSourceType,
  TagKindDynamicString,
  KindDynamicString,
  TagKindDynamicBoolean,
  KindDynamicBoolean,
  TagKindDynamicNumber,
  KindDynamicNumber,
  TagKindDynamicVoid,
  KindDynamicVoid,
  TagKindChannel,
  KindChannel,
  TagKindPrimarySkill,
  KindPrimarySkill,
  TagKindSkill,
  KindSkill,
  TagKindKeyQuality,
  KindKeyQuality,
  TagKindClassification,
  KindClassification,
  Language,
  ChannelMetadataArray,
} from "../schema";

export function serialize_ChannelMetadataArray(obj: ChannelMetadataArray): string {
  const serialized = ((value: { channelMetadata: ChannelMetadata[] }): unknown => {
    return {
      channelMetadata: ((value: ChannelMetadata[]): unknown => {
        return value.map(
          (value: {
            activationTime: DateTime<true> | null;
            active: boolean;
            channelId: bigint;
            channelLocalization: { additionalProperties: Record<string, ChannelTextLocalization> };
            coverUri: string | null;
            definition: string | null;
            descriptionHtml: string | null;
            modificationTime: DateTime<true> | null;
            name: string;
            synonyms: string | null;
            tag: Tag;
            title: string | null;
            visibleLanguages: Language[];
          }): unknown => {
            return {
              activationTime: ((value: DateTime<true> | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value.toMillis();
              })(value["activationTime"]),
              active: ((value: boolean): unknown => {
                return value;
              })(value["active"]),
              channelId: ((value: bigint): unknown => {
                return value;
              })(value["channelId"]),
              channelLocalization: ((value: { additionalProperties: Record<string, ChannelTextLocalization> }): unknown => {
                const unordered_obj: Record<string, unknown> = {
                  ...Object.fromEntries(
                    Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
                      return [
                        propertyKey,
                        ((value: { description: string | null; synonym: string | null; title: string | null }): unknown => {
                          return {
                            description: ((value: string | null): unknown => {
                              if (value === null) {
                                return null;
                              }
                              return value;
                            })(value["description"]),
                            synonym: ((value: string | null): unknown => {
                              if (value === null) {
                                return null;
                              }
                              return value;
                            })(value["synonym"]),
                            title: ((value: string | null): unknown => {
                              if (value === null) {
                                return null;
                              }
                              return value;
                            })(value["title"]),
                          };
                        })(propertyValue),
                      ];
                    }),
                  ),
                };
                return Object.keys(unordered_obj)
                  .sort()
                  .reduce(
                    (obj, key) => {
                      obj[key] = unordered_obj[key];
                      return obj;
                    },
                    {} as Record<string, unknown>,
                  );
              })(value["channelLocalization"]),
              coverUri: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["coverUri"]),
              definition: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["definition"]),
              descriptionHtml: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["descriptionHtml"]),
              modificationTime: ((value: DateTime<true> | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value.toMillis();
              })(value["modificationTime"]),
              name: ((value: string): unknown => {
                return value;
              })(value["name"]),
              synonyms: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["synonyms"]),
              tag: ((
                value:
                  | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
                  | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
                  | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
                  | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
                  | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
                  | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
                  | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
                  | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
                  | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string },
              ): unknown => {
                switch (value.discriminator) {
                  case "dynamicString": {
                    return {
                      discriminator: "dynamicString",
                      exclude: ((value: boolean): unknown => {
                        return value;
                      })(value["exclude"]),
                      score: ((value: number): unknown => {
                        return value;
                      })(value["score"]),
                      source: ((value: "USER" | "AI"): unknown => {
                        return value;
                      })(value["source"]),
                      tagKind: ((value: { discriminator: KindDynamicString; id: bigint; kind: string }): unknown => {
                        return {
                          discriminator: ((value: "dynamicString"): unknown => {
                            return value;
                          })(value["discriminator"]),
                          id: ((value: bigint): unknown => {
                            return value;
                          })(value["id"]),
                          kind: ((value: string): unknown => {
                            return value;
                          })(value["kind"]),
                        };
                      })(value["tagKind"]),
                      value: ((value: string): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  }
                  case "dynamicBoolean": {
                    return {
                      discriminator: "dynamicBoolean",
                      exclude: ((value: boolean): unknown => {
                        return value;
                      })(value["exclude"]),
                      score: ((value: number): unknown => {
                        return value;
                      })(value["score"]),
                      source: ((value: "USER" | "AI"): unknown => {
                        return value;
                      })(value["source"]),
                      tagKind: ((value: { discriminator: KindDynamicBoolean; id: bigint; kind: string }): unknown => {
                        return {
                          discriminator: ((value: "dynamicBoolean"): unknown => {
                            return value;
                          })(value["discriminator"]),
                          id: ((value: bigint): unknown => {
                            return value;
                          })(value["id"]),
                          kind: ((value: string): unknown => {
                            return value;
                          })(value["kind"]),
                        };
                      })(value["tagKind"]),
                      value: ((value: boolean): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  }
                  case "dynamicNumber": {
                    return {
                      discriminator: "dynamicNumber",
                      exclude: ((value: boolean): unknown => {
                        return value;
                      })(value["exclude"]),
                      score: ((value: number): unknown => {
                        return value;
                      })(value["score"]),
                      source: ((value: "USER" | "AI"): unknown => {
                        return value;
                      })(value["source"]),
                      tagKind: ((value: { discriminator: KindDynamicNumber; id: bigint; kind: string }): unknown => {
                        return {
                          discriminator: ((value: "dynamicNumber"): unknown => {
                            return value;
                          })(value["discriminator"]),
                          id: ((value: bigint): unknown => {
                            return value;
                          })(value["id"]),
                          kind: ((value: string): unknown => {
                            return value;
                          })(value["kind"]),
                        };
                      })(value["tagKind"]),
                      value: ((value: number): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  }
                  case "dynamicVoid": {
                    return {
                      discriminator: "dynamicVoid",
                      exclude: ((value: boolean): unknown => {
                        return value;
                      })(value["exclude"]),
                      score: ((value: number): unknown => {
                        return value;
                      })(value["score"]),
                      source: ((value: "USER" | "AI"): unknown => {
                        return value;
                      })(value["source"]),
                      tagKind: ((value: { discriminator: KindDynamicVoid; id: bigint; kind: string }): unknown => {
                        return {
                          discriminator: ((value: "dynamicVoid"): unknown => {
                            return value;
                          })(value["discriminator"]),
                          id: ((value: bigint): unknown => {
                            return value;
                          })(value["id"]),
                          kind: ((value: string): unknown => {
                            return value;
                          })(value["kind"]),
                        };
                      })(value["tagKind"]),
                    };
                  }
                  case "channel": {
                    return {
                      discriminator: "channel",
                      exclude: ((value: boolean): unknown => {
                        return value;
                      })(value["exclude"]),
                      score: ((value: number): unknown => {
                        return value;
                      })(value["score"]),
                      source: ((value: "USER" | "AI"): unknown => {
                        return value;
                      })(value["source"]),
                      tagKind: ((value: { discriminator: KindChannel; id: bigint; kind: KindChannel }): unknown => {
                        return {
                          discriminator: ((value: "channel"): unknown => {
                            return value;
                          })(value["discriminator"]),
                          id: ((value: bigint): unknown => {
                            return value;
                          })(value["id"]),
                          kind: ((value: "channel"): unknown => {
                            return value;
                          })(value["kind"]),
                        };
                      })(value["tagKind"]),
                      value: ((value: string): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  }
                  case "primary-skill": {
                    return {
                      discriminator: "primary-skill",
                      exclude: ((value: boolean): unknown => {
                        return value;
                      })(value["exclude"]),
                      score: ((value: number): unknown => {
                        return value;
                      })(value["score"]),
                      source: ((value: "USER" | "AI"): unknown => {
                        return value;
                      })(value["source"]),
                      tagKind: ((value: { discriminator: KindPrimarySkill; id: bigint; kind: KindPrimarySkill }): unknown => {
                        return {
                          discriminator: ((value: "primary-skill"): unknown => {
                            return value;
                          })(value["discriminator"]),
                          id: ((value: bigint): unknown => {
                            return value;
                          })(value["id"]),
                          kind: ((value: "primary-skill"): unknown => {
                            return value;
                          })(value["kind"]),
                        };
                      })(value["tagKind"]),
                      value: ((value: string): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  }
                  case "skill": {
                    return {
                      discriminator: "skill",
                      exclude: ((value: boolean): unknown => {
                        return value;
                      })(value["exclude"]),
                      score: ((value: number): unknown => {
                        return value;
                      })(value["score"]),
                      source: ((value: "USER" | "AI"): unknown => {
                        return value;
                      })(value["source"]),
                      tagKind: ((value: { discriminator: KindSkill; id: bigint; kind: KindSkill }): unknown => {
                        return {
                          discriminator: ((value: "skill"): unknown => {
                            return value;
                          })(value["discriminator"]),
                          id: ((value: bigint): unknown => {
                            return value;
                          })(value["id"]),
                          kind: ((value: "skill"): unknown => {
                            return value;
                          })(value["kind"]),
                        };
                      })(value["tagKind"]),
                      value: ((value: string): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  }
                  case "key-quality": {
                    return {
                      discriminator: "key-quality",
                      exclude: ((value: boolean): unknown => {
                        return value;
                      })(value["exclude"]),
                      score: ((value: number): unknown => {
                        return value;
                      })(value["score"]),
                      source: ((value: "USER" | "AI"): unknown => {
                        return value;
                      })(value["source"]),
                      tagKind: ((value: { discriminator: KindKeyQuality; id: bigint; kind: KindKeyQuality }): unknown => {
                        return {
                          discriminator: ((value: "key-quality"): unknown => {
                            return value;
                          })(value["discriminator"]),
                          id: ((value: bigint): unknown => {
                            return value;
                          })(value["id"]),
                          kind: ((value: "key-quality"): unknown => {
                            return value;
                          })(value["kind"]),
                        };
                      })(value["tagKind"]),
                      value: ((value: string): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  }
                  case "classification": {
                    return {
                      discriminator: "classification",
                      exclude: ((value: boolean): unknown => {
                        return value;
                      })(value["exclude"]),
                      score: ((value: number): unknown => {
                        return value;
                      })(value["score"]),
                      source: ((value: "USER" | "AI"): unknown => {
                        return value;
                      })(value["source"]),
                      tagKind: ((value: { discriminator: KindClassification; id: bigint; kind: KindClassification }): unknown => {
                        return {
                          discriminator: ((value: "classification"): unknown => {
                            return value;
                          })(value["discriminator"]),
                          id: ((value: bigint): unknown => {
                            return value;
                          })(value["id"]),
                          kind: ((value: "classification"): unknown => {
                            return value;
                          })(value["kind"]),
                        };
                      })(value["tagKind"]),
                      value: ((value: string): unknown => {
                        return value;
                      })(value["value"]),
                    };
                  }
                }
              })(value["tag"]),
              title: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["title"]),
              visibleLanguages: ((value: Language[]): unknown => {
                return value.map((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
                  return value;
                });
              })(value["visibleLanguages"]),
            };
          },
        );
      })(value["channelMetadata"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_ChannelMetadataArray(str: string): ParserResult<ChannelMetadataArray> {
  return ((
    value: unknown,
  ): ParserResult<{
    channelMetadata: ChannelMetadata[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ChannelMetadataArray]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ChannelMetadataArray]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "channelMetadata")) {
      return { success: false, reason: `[#/components/schemas/ChannelMetadataArray/channelMetadata]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'channelMetadata'.` };
    }
    const parsed_channelMetadata = ((): ParserResult<ChannelMetadata[]> => {
      return ((value: unknown): ParserResult<ChannelMetadata[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ChannelMetadataArray/channelMetadata]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<ChannelMetadata> => {
          return ((
            value: unknown,
          ): ParserResult<{
            activationTime: DateTime<true> | null;
            active: boolean;
            channelId: bigint;
            channelLocalization: { additionalProperties: Record<string, ChannelTextLocalization> };
            coverUri: string | null;
            definition: string | null;
            descriptionHtml: string | null;
            modificationTime: DateTime<true> | null;
            name: string;
            synonyms: string | null;
            tag: Tag;
            title: string | null;
            visibleLanguages: Language[];
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "activationTime")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/activationTime]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activationTime'.` };
            }
            const parsed_activationTime = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/activationTime]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/activationTime]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["activationTime"]);
            })();
            if (!parsed_activationTime.success) {
              return { success: false, reason: parsed_activationTime.reason };
            }
            if (!hasProp(value, "active")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/active]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'active'.` };
            }
            const parsed_active = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/active]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["active"]);
            })();
            if (!parsed_active.success) {
              return { success: false, reason: parsed_active.reason };
            }
            if (!hasProp(value, "channelId")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/channelId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'channelId'.` };
            }
            const parsed_channelId = ((): ParserResult<bigint> => {
              return ((value: unknown): ParserResult<bigint> => {
                if (typeof value === "number") {
                  return { success: true, value: BigInt(value) };
                }
                if (typeof value === "bigint") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/ChannelMetadata/channelId]: '${value}' expected to be of type bigint or number.` };
              })(value["channelId"]);
            })();
            if (!parsed_channelId.success) {
              return { success: false, reason: parsed_channelId.reason };
            }
            if (!hasProp(value, "channelLocalization")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/channelLocalization]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'channelLocalization'.` };
            }
            const parsed_channelLocalization = ((): ParserResult<{ additionalProperties: Record<string, ChannelTextLocalization> }> => {
              return ((value: unknown): ParserResult<{ additionalProperties: Record<string, ChannelTextLocalization> }> => {
                if (typeof value !== "object") {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/channelLocalization]: '${value}' expected to be of type 'object'.` };
                }
                if (value === null) {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/channelLocalization]: '${value}' expected to not be null.` };
                }
                const parsed_additionalProperties = ((): ParserResult<Record<string, ChannelTextLocalization>> => {
                  const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<ChannelTextLocalization>] => {
                    return [
                      key,
                      ((value: unknown): ParserResult<ChannelTextLocalization> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          description: string | null;
                          synonym: string | null;
                          title: string | null;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/ChannelTextLocalization]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/ChannelTextLocalization]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "description")) {
                            return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/description]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'description'.` };
                          }
                          const parsed_description = ((): ParserResult<string | null> => {
                            return ((value: unknown): ParserResult<string | null> => {
                              if (value === null) {
                                return { success: true, value: null };
                              }
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/description]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["description"]);
                          })();
                          if (!parsed_description.success) {
                            return { success: false, reason: parsed_description.reason };
                          }
                          if (!hasProp(value, "synonym")) {
                            return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/synonym]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'synonym'.` };
                          }
                          const parsed_synonym = ((): ParserResult<string | null> => {
                            return ((value: unknown): ParserResult<string | null> => {
                              if (value === null) {
                                return { success: true, value: null };
                              }
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/synonym]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["synonym"]);
                          })();
                          if (!parsed_synonym.success) {
                            return { success: false, reason: parsed_synonym.reason };
                          }
                          if (!hasProp(value, "title")) {
                            return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                          }
                          const parsed_title = ((): ParserResult<string | null> => {
                            return ((value: unknown): ParserResult<string | null> => {
                              if (value === null) {
                                return { success: true, value: null };
                              }
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/ChannelTextLocalization/title]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["title"]);
                          })();
                          if (!parsed_title.success) {
                            return { success: false, reason: parsed_title.reason };
                          }
                          return { success: true, value: { description: parsed_description.value, synonym: parsed_synonym.value, title: parsed_title.value } };
                        })(value);
                      })(value),
                    ];
                  });
                  if (parsed.find(([_, value]) => !value.success) !== undefined) {
                    return {
                      success: false,
                      reason: `[#/components/schemas/ChannelMetadata/channelLocalization]: Reason(s): '${parsed
                        .map(([_, value]) => value)
                        .filter((p) => !p.success)
                        .map((p) => p.reason)
                        .join(", ")}'.`,
                    };
                  }
                  return {
                    success: true,
                    value: Object.fromEntries(
                      parsed.map(([key, value]) => {
                        assert(value.success);
                        return [key, value.value];
                      }),
                    ),
                  };
                })();
                if (!parsed_additionalProperties.success) {
                  return { success: false, reason: parsed_additionalProperties.reason };
                }
                return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
              })(value["channelLocalization"]);
            })();
            if (!parsed_channelLocalization.success) {
              return { success: false, reason: parsed_channelLocalization.reason };
            }
            if (!hasProp(value, "coverUri")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
            }
            const parsed_coverUri = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/coverUri]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["coverUri"]);
            })();
            if (!parsed_coverUri.success) {
              return { success: false, reason: parsed_coverUri.reason };
            }
            if (!hasProp(value, "definition")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/definition]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'definition'.` };
            }
            const parsed_definition = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/definition]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["definition"]);
            })();
            if (!parsed_definition.success) {
              return { success: false, reason: parsed_definition.reason };
            }
            if (!hasProp(value, "descriptionHtml")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/descriptionHtml]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'descriptionHtml'.` };
            }
            const parsed_descriptionHtml = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/descriptionHtml]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["descriptionHtml"]);
            })();
            if (!parsed_descriptionHtml.success) {
              return { success: false, reason: parsed_descriptionHtml.reason };
            }
            if (!hasProp(value, "modificationTime")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/modificationTime]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'modificationTime'.` };
            }
            const parsed_modificationTime = ((): ParserResult<DateTime<true> | null> => {
              return ((value: unknown): ParserResult<DateTime<true> | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/modificationTime]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/modificationTime]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["modificationTime"]);
            })();
            if (!parsed_modificationTime.success) {
              return { success: false, reason: parsed_modificationTime.reason };
            }
            if (!hasProp(value, "name")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
            }
            const parsed_name = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/name]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["name"]);
            })();
            if (!parsed_name.success) {
              return { success: false, reason: parsed_name.reason };
            }
            if (!hasProp(value, "synonyms")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/synonyms]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'synonyms'.` };
            }
            const parsed_synonyms = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/synonyms]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["synonyms"]);
            })();
            if (!parsed_synonyms.success) {
              return { success: false, reason: parsed_synonyms.reason };
            }
            if (!hasProp(value, "tag")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/tag]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tag'.` };
            }
            const parsed_tag = ((): ParserResult<Tag> => {
              return ((value: unknown): ParserResult<Tag> => {
                return ((
                  value: unknown,
                ): ParserResult<
                  | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
                  | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
                  | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
                  | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
                  | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
                  | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
                  | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
                  | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
                  | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
                > => {
                  return ((
                    value: unknown,
                  ): ParserResult<
                    | { discriminator: "dynamicString"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicString; value: string }
                    | { discriminator: "dynamicBoolean"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicBoolean; value: boolean }
                    | { discriminator: "dynamicNumber"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicNumber; value: number }
                    | { discriminator: "dynamicVoid"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindDynamicVoid }
                    | { discriminator: "channel"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindChannel; value: string }
                    | { discriminator: "primary-skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindPrimarySkill; value: string }
                    | { discriminator: "skill"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindSkill; value: string }
                    | { discriminator: "key-quality"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindKeyQuality; value: string }
                    | { discriminator: "classification"; exclude: boolean; score: number; source: TagSourceType; tagKind: TagKindClassification; value: string }
                  > => {
                    if (value == null) {
                      return { success: false, reason: `[#/components/schemas/Tag]: '${value}' expected to be non-null.` };
                    }
                    if (typeof value != "object") {
                      return { success: false, reason: `[#/components/schemas/Tag]: ${value} expected to be of type 'object'.` };
                    }
                    if (!hasProp(value, "discriminator")) {
                      return { success: false, reason: `[#/components/schemas/Tag]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                    }
                    if (typeof value["discriminator"] != "string") {
                      return { success: false, reason: `[#/components/schemas/Tag]: '${value["discriminator"]}' expected to be of type 'string'.` };
                    }
                    const discriminator = value["discriminator"];
                    switch (discriminator) {
                      case "dynamicString": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          exclude: boolean;
                          score: number;
                          source: TagSourceType;
                          tagKind: TagKindDynamicString;
                          value: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicString]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicString]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "exclude")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicString/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                          }
                          const parsed_exclude = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/Tag/dynamicString/exclude]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["exclude"]);
                          })();
                          if (!parsed_exclude.success) {
                            return { success: false, reason: parsed_exclude.reason };
                          }
                          if (!hasProp(value, "score")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicString/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                          }
                          const parsed_score = ((): ParserResult<number> => {
                            return ((value: unknown): ParserResult<number> => {
                              if (typeof value === "number") {
                                return { success: true, value: value };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: Number(value) };
                              }
                              return { success: false, reason: `[#/components/schemas/Tag/dynamicString/score]: '${value}' expected to be of type number or bigint.` };
                            })(value["score"]);
                          })();
                          if (!parsed_score.success) {
                            return { success: false, reason: parsed_score.reason };
                          }
                          if (!hasProp(value, "source")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicString/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                          }
                          const parsed_source = ((): ParserResult<TagSourceType> => {
                            return ((value: unknown): ParserResult<TagSourceType> => {
                              return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "USER":
                                    return { success: true, value: "USER" };
                                  case "AI":
                                    return { success: true, value: "AI" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                }
                              })(value);
                            })(value["source"]);
                          })();
                          if (!parsed_source.success) {
                            return { success: false, reason: parsed_source.reason };
                          }
                          if (!hasProp(value, "tagKind")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicString/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                          }
                          const parsed_tagKind = ((): ParserResult<TagKindDynamicString> => {
                            return ((value: unknown): ParserResult<TagKindDynamicString> => {
                              return ((
                                value: unknown,
                              ): ParserResult<{
                                discriminator: KindDynamicString;
                                id: bigint;
                                kind: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicString]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicString]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "discriminator")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicString/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                }
                                const parsed_discriminator = ((): ParserResult<KindDynamicString> => {
                                  return ((value: unknown): ParserResult<KindDynamicString> => {
                                    return ((value: unknown): ParserResult<"dynamicString"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindDynamicString]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "dynamicString":
                                          return { success: true, value: "dynamicString" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindDynamicString]: '${value}' expected to be enum, one of 'dynamicString'.` };
                                      }
                                    })(value);
                                  })(value["discriminator"]);
                                })();
                                if (!parsed_discriminator.success) {
                                  return { success: false, reason: parsed_discriminator.reason };
                                }
                                if (!hasProp(value, "id")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicString/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                }
                                const parsed_id = ((): ParserResult<bigint> => {
                                  return ((value: unknown): ParserResult<bigint> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: BigInt(value) };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/TagKindDynamicString/id]: '${value}' expected to be of type bigint or number.` };
                                  })(value["id"]);
                                })();
                                if (!parsed_id.success) {
                                  return { success: false, reason: parsed_id.reason };
                                }
                                if (!hasProp(value, "kind")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicString/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                }
                                const parsed_kind = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/TagKindDynamicString/kind]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["kind"]);
                                })();
                                if (!parsed_kind.success) {
                                  return { success: false, reason: parsed_kind.reason };
                                }
                                return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                              })(value);
                            })(value["tagKind"]);
                          })();
                          if (!parsed_tagKind.success) {
                            return { success: false, reason: parsed_tagKind.reason };
                          }
                          if (!hasProp(value, "value")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicString/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                          }
                          const parsed_value = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/Tag/dynamicString/value]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["value"]);
                          })();
                          if (!parsed_value.success) {
                            return { success: false, reason: parsed_value.reason };
                          }
                          return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { discriminator: "dynamicString" as const, ...parsedVariant.value } };
                      }
                      case "dynamicBoolean": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          exclude: boolean;
                          score: number;
                          source: TagSourceType;
                          tagKind: TagKindDynamicBoolean;
                          value: boolean;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "exclude")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                          }
                          const parsed_exclude = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/exclude]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["exclude"]);
                          })();
                          if (!parsed_exclude.success) {
                            return { success: false, reason: parsed_exclude.reason };
                          }
                          if (!hasProp(value, "score")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                          }
                          const parsed_score = ((): ParserResult<number> => {
                            return ((value: unknown): ParserResult<number> => {
                              if (typeof value === "number") {
                                return { success: true, value: value };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: Number(value) };
                              }
                              return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/score]: '${value}' expected to be of type number or bigint.` };
                            })(value["score"]);
                          })();
                          if (!parsed_score.success) {
                            return { success: false, reason: parsed_score.reason };
                          }
                          if (!hasProp(value, "source")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                          }
                          const parsed_source = ((): ParserResult<TagSourceType> => {
                            return ((value: unknown): ParserResult<TagSourceType> => {
                              return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "USER":
                                    return { success: true, value: "USER" };
                                  case "AI":
                                    return { success: true, value: "AI" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                }
                              })(value);
                            })(value["source"]);
                          })();
                          if (!parsed_source.success) {
                            return { success: false, reason: parsed_source.reason };
                          }
                          if (!hasProp(value, "tagKind")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                          }
                          const parsed_tagKind = ((): ParserResult<TagKindDynamicBoolean> => {
                            return ((value: unknown): ParserResult<TagKindDynamicBoolean> => {
                              return ((
                                value: unknown,
                              ): ParserResult<{
                                discriminator: KindDynamicBoolean;
                                id: bigint;
                                kind: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "discriminator")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                }
                                const parsed_discriminator = ((): ParserResult<KindDynamicBoolean> => {
                                  return ((value: unknown): ParserResult<KindDynamicBoolean> => {
                                    return ((value: unknown): ParserResult<"dynamicBoolean"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindDynamicBoolean]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "dynamicBoolean":
                                          return { success: true, value: "dynamicBoolean" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindDynamicBoolean]: '${value}' expected to be enum, one of 'dynamicBoolean'.` };
                                      }
                                    })(value);
                                  })(value["discriminator"]);
                                })();
                                if (!parsed_discriminator.success) {
                                  return { success: false, reason: parsed_discriminator.reason };
                                }
                                if (!hasProp(value, "id")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                }
                                const parsed_id = ((): ParserResult<bigint> => {
                                  return ((value: unknown): ParserResult<bigint> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: BigInt(value) };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/id]: '${value}' expected to be of type bigint or number.` };
                                  })(value["id"]);
                                })();
                                if (!parsed_id.success) {
                                  return { success: false, reason: parsed_id.reason };
                                }
                                if (!hasProp(value, "kind")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                }
                                const parsed_kind = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/TagKindDynamicBoolean/kind]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["kind"]);
                                })();
                                if (!parsed_kind.success) {
                                  return { success: false, reason: parsed_kind.reason };
                                }
                                return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                              })(value);
                            })(value["tagKind"]);
                          })();
                          if (!parsed_tagKind.success) {
                            return { success: false, reason: parsed_tagKind.reason };
                          }
                          if (!hasProp(value, "value")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                          }
                          const parsed_value = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/Tag/dynamicBoolean/value]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["value"]);
                          })();
                          if (!parsed_value.success) {
                            return { success: false, reason: parsed_value.reason };
                          }
                          return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { discriminator: "dynamicBoolean" as const, ...parsedVariant.value } };
                      }
                      case "dynamicNumber": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          exclude: boolean;
                          score: number;
                          source: TagSourceType;
                          tagKind: TagKindDynamicNumber;
                          value: number;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "exclude")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                          }
                          const parsed_exclude = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/exclude]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["exclude"]);
                          })();
                          if (!parsed_exclude.success) {
                            return { success: false, reason: parsed_exclude.reason };
                          }
                          if (!hasProp(value, "score")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                          }
                          const parsed_score = ((): ParserResult<number> => {
                            return ((value: unknown): ParserResult<number> => {
                              if (typeof value === "number") {
                                return { success: true, value: value };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: Number(value) };
                              }
                              return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/score]: '${value}' expected to be of type number or bigint.` };
                            })(value["score"]);
                          })();
                          if (!parsed_score.success) {
                            return { success: false, reason: parsed_score.reason };
                          }
                          if (!hasProp(value, "source")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                          }
                          const parsed_source = ((): ParserResult<TagSourceType> => {
                            return ((value: unknown): ParserResult<TagSourceType> => {
                              return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "USER":
                                    return { success: true, value: "USER" };
                                  case "AI":
                                    return { success: true, value: "AI" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                }
                              })(value);
                            })(value["source"]);
                          })();
                          if (!parsed_source.success) {
                            return { success: false, reason: parsed_source.reason };
                          }
                          if (!hasProp(value, "tagKind")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                          }
                          const parsed_tagKind = ((): ParserResult<TagKindDynamicNumber> => {
                            return ((value: unknown): ParserResult<TagKindDynamicNumber> => {
                              return ((
                                value: unknown,
                              ): ParserResult<{
                                discriminator: KindDynamicNumber;
                                id: bigint;
                                kind: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "discriminator")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                }
                                const parsed_discriminator = ((): ParserResult<KindDynamicNumber> => {
                                  return ((value: unknown): ParserResult<KindDynamicNumber> => {
                                    return ((value: unknown): ParserResult<"dynamicNumber"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindDynamicNumber]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "dynamicNumber":
                                          return { success: true, value: "dynamicNumber" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindDynamicNumber]: '${value}' expected to be enum, one of 'dynamicNumber'.` };
                                      }
                                    })(value);
                                  })(value["discriminator"]);
                                })();
                                if (!parsed_discriminator.success) {
                                  return { success: false, reason: parsed_discriminator.reason };
                                }
                                if (!hasProp(value, "id")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                }
                                const parsed_id = ((): ParserResult<bigint> => {
                                  return ((value: unknown): ParserResult<bigint> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: BigInt(value) };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/id]: '${value}' expected to be of type bigint or number.` };
                                  })(value["id"]);
                                })();
                                if (!parsed_id.success) {
                                  return { success: false, reason: parsed_id.reason };
                                }
                                if (!hasProp(value, "kind")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                }
                                const parsed_kind = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/TagKindDynamicNumber/kind]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["kind"]);
                                })();
                                if (!parsed_kind.success) {
                                  return { success: false, reason: parsed_kind.reason };
                                }
                                return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                              })(value);
                            })(value["tagKind"]);
                          })();
                          if (!parsed_tagKind.success) {
                            return { success: false, reason: parsed_tagKind.reason };
                          }
                          if (!hasProp(value, "value")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                          }
                          const parsed_value = ((): ParserResult<number> => {
                            return ((value: unknown): ParserResult<number> => {
                              if (typeof value === "number") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/Tag/dynamicNumber/value]: '${value}' expected to be of type number.` };
                            })(value["value"]);
                          })();
                          if (!parsed_value.success) {
                            return { success: false, reason: parsed_value.reason };
                          }
                          return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { discriminator: "dynamicNumber" as const, ...parsedVariant.value } };
                      }
                      case "dynamicVoid": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          exclude: boolean;
                          score: number;
                          source: TagSourceType;
                          tagKind: TagKindDynamicVoid;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "exclude")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                          }
                          const parsed_exclude = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/exclude]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["exclude"]);
                          })();
                          if (!parsed_exclude.success) {
                            return { success: false, reason: parsed_exclude.reason };
                          }
                          if (!hasProp(value, "score")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                          }
                          const parsed_score = ((): ParserResult<number> => {
                            return ((value: unknown): ParserResult<number> => {
                              if (typeof value === "number") {
                                return { success: true, value: value };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: Number(value) };
                              }
                              return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/score]: '${value}' expected to be of type number or bigint.` };
                            })(value["score"]);
                          })();
                          if (!parsed_score.success) {
                            return { success: false, reason: parsed_score.reason };
                          }
                          if (!hasProp(value, "source")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                          }
                          const parsed_source = ((): ParserResult<TagSourceType> => {
                            return ((value: unknown): ParserResult<TagSourceType> => {
                              return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "USER":
                                    return { success: true, value: "USER" };
                                  case "AI":
                                    return { success: true, value: "AI" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                }
                              })(value);
                            })(value["source"]);
                          })();
                          if (!parsed_source.success) {
                            return { success: false, reason: parsed_source.reason };
                          }
                          if (!hasProp(value, "tagKind")) {
                            return { success: false, reason: `[#/components/schemas/Tag/dynamicVoid/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                          }
                          const parsed_tagKind = ((): ParserResult<TagKindDynamicVoid> => {
                            return ((value: unknown): ParserResult<TagKindDynamicVoid> => {
                              return ((
                                value: unknown,
                              ): ParserResult<{
                                discriminator: KindDynamicVoid;
                                id: bigint;
                                kind: string;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "discriminator")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                }
                                const parsed_discriminator = ((): ParserResult<KindDynamicVoid> => {
                                  return ((value: unknown): ParserResult<KindDynamicVoid> => {
                                    return ((value: unknown): ParserResult<"dynamicVoid"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindDynamicVoid]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "dynamicVoid":
                                          return { success: true, value: "dynamicVoid" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindDynamicVoid]: '${value}' expected to be enum, one of 'dynamicVoid'.` };
                                      }
                                    })(value);
                                  })(value["discriminator"]);
                                })();
                                if (!parsed_discriminator.success) {
                                  return { success: false, reason: parsed_discriminator.reason };
                                }
                                if (!hasProp(value, "id")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                }
                                const parsed_id = ((): ParserResult<bigint> => {
                                  return ((value: unknown): ParserResult<bigint> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: BigInt(value) };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/id]: '${value}' expected to be of type bigint or number.` };
                                  })(value["id"]);
                                })();
                                if (!parsed_id.success) {
                                  return { success: false, reason: parsed_id.reason };
                                }
                                if (!hasProp(value, "kind")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                }
                                const parsed_kind = ((): ParserResult<string> => {
                                  return ((value: unknown): ParserResult<string> => {
                                    if (typeof value !== "string") {
                                      return { success: false, reason: `[#/components/schemas/TagKindDynamicVoid/kind]: '${value}' expected to be of type string.` };
                                    }
                                    return { success: true, value: value };
                                  })(value["kind"]);
                                })();
                                if (!parsed_kind.success) {
                                  return { success: false, reason: parsed_kind.reason };
                                }
                                return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                              })(value);
                            })(value["tagKind"]);
                          })();
                          if (!parsed_tagKind.success) {
                            return { success: false, reason: parsed_tagKind.reason };
                          }
                          return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { discriminator: "dynamicVoid" as const, ...parsedVariant.value } };
                      }
                      case "channel": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          exclude: boolean;
                          score: number;
                          source: TagSourceType;
                          tagKind: TagKindChannel;
                          value: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/Tag/channel]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/Tag/channel]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "exclude")) {
                            return { success: false, reason: `[#/components/schemas/Tag/channel/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                          }
                          const parsed_exclude = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/Tag/channel/exclude]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["exclude"]);
                          })();
                          if (!parsed_exclude.success) {
                            return { success: false, reason: parsed_exclude.reason };
                          }
                          if (!hasProp(value, "score")) {
                            return { success: false, reason: `[#/components/schemas/Tag/channel/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                          }
                          const parsed_score = ((): ParserResult<number> => {
                            return ((value: unknown): ParserResult<number> => {
                              if (typeof value === "number") {
                                return { success: true, value: value };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: Number(value) };
                              }
                              return { success: false, reason: `[#/components/schemas/Tag/channel/score]: '${value}' expected to be of type number or bigint.` };
                            })(value["score"]);
                          })();
                          if (!parsed_score.success) {
                            return { success: false, reason: parsed_score.reason };
                          }
                          if (!hasProp(value, "source")) {
                            return { success: false, reason: `[#/components/schemas/Tag/channel/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                          }
                          const parsed_source = ((): ParserResult<TagSourceType> => {
                            return ((value: unknown): ParserResult<TagSourceType> => {
                              return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "USER":
                                    return { success: true, value: "USER" };
                                  case "AI":
                                    return { success: true, value: "AI" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                }
                              })(value);
                            })(value["source"]);
                          })();
                          if (!parsed_source.success) {
                            return { success: false, reason: parsed_source.reason };
                          }
                          if (!hasProp(value, "tagKind")) {
                            return { success: false, reason: `[#/components/schemas/Tag/channel/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                          }
                          const parsed_tagKind = ((): ParserResult<TagKindChannel> => {
                            return ((value: unknown): ParserResult<TagKindChannel> => {
                              return ((
                                value: unknown,
                              ): ParserResult<{
                                discriminator: KindChannel;
                                id: bigint;
                                kind: KindChannel;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/TagKindChannel]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/TagKindChannel]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "discriminator")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindChannel/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                }
                                const parsed_discriminator = ((): ParserResult<KindChannel> => {
                                  return ((value: unknown): ParserResult<KindChannel> => {
                                    return ((value: unknown): ParserResult<"channel"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "channel":
                                          return { success: true, value: "channel" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be enum, one of 'channel'.` };
                                      }
                                    })(value);
                                  })(value["discriminator"]);
                                })();
                                if (!parsed_discriminator.success) {
                                  return { success: false, reason: parsed_discriminator.reason };
                                }
                                if (!hasProp(value, "id")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindChannel/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                }
                                const parsed_id = ((): ParserResult<bigint> => {
                                  return ((value: unknown): ParserResult<bigint> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: BigInt(value) };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/TagKindChannel/id]: '${value}' expected to be of type bigint or number.` };
                                  })(value["id"]);
                                })();
                                if (!parsed_id.success) {
                                  return { success: false, reason: parsed_id.reason };
                                }
                                if (!hasProp(value, "kind")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindChannel/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                }
                                const parsed_kind = ((): ParserResult<KindChannel> => {
                                  return ((value: unknown): ParserResult<KindChannel> => {
                                    return ((value: unknown): ParserResult<"channel"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "channel":
                                          return { success: true, value: "channel" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be enum, one of 'channel'.` };
                                      }
                                    })(value);
                                  })(value["kind"]);
                                })();
                                if (!parsed_kind.success) {
                                  return { success: false, reason: parsed_kind.reason };
                                }
                                return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                              })(value);
                            })(value["tagKind"]);
                          })();
                          if (!parsed_tagKind.success) {
                            return { success: false, reason: parsed_tagKind.reason };
                          }
                          if (!hasProp(value, "value")) {
                            return { success: false, reason: `[#/components/schemas/Tag/channel/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                          }
                          const parsed_value = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/Tag/channel/value]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["value"]);
                          })();
                          if (!parsed_value.success) {
                            return { success: false, reason: parsed_value.reason };
                          }
                          return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { discriminator: "channel" as const, ...parsedVariant.value } };
                      }
                      case "primary-skill": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          exclude: boolean;
                          score: number;
                          source: TagSourceType;
                          tagKind: TagKindPrimarySkill;
                          value: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/Tag/primary-skill]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/Tag/primary-skill]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "exclude")) {
                            return { success: false, reason: `[#/components/schemas/Tag/primary-skill/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                          }
                          const parsed_exclude = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/Tag/primary-skill/exclude]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["exclude"]);
                          })();
                          if (!parsed_exclude.success) {
                            return { success: false, reason: parsed_exclude.reason };
                          }
                          if (!hasProp(value, "score")) {
                            return { success: false, reason: `[#/components/schemas/Tag/primary-skill/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                          }
                          const parsed_score = ((): ParserResult<number> => {
                            return ((value: unknown): ParserResult<number> => {
                              if (typeof value === "number") {
                                return { success: true, value: value };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: Number(value) };
                              }
                              return { success: false, reason: `[#/components/schemas/Tag/primary-skill/score]: '${value}' expected to be of type number or bigint.` };
                            })(value["score"]);
                          })();
                          if (!parsed_score.success) {
                            return { success: false, reason: parsed_score.reason };
                          }
                          if (!hasProp(value, "source")) {
                            return { success: false, reason: `[#/components/schemas/Tag/primary-skill/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                          }
                          const parsed_source = ((): ParserResult<TagSourceType> => {
                            return ((value: unknown): ParserResult<TagSourceType> => {
                              return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "USER":
                                    return { success: true, value: "USER" };
                                  case "AI":
                                    return { success: true, value: "AI" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                }
                              })(value);
                            })(value["source"]);
                          })();
                          if (!parsed_source.success) {
                            return { success: false, reason: parsed_source.reason };
                          }
                          if (!hasProp(value, "tagKind")) {
                            return { success: false, reason: `[#/components/schemas/Tag/primary-skill/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                          }
                          const parsed_tagKind = ((): ParserResult<TagKindPrimarySkill> => {
                            return ((value: unknown): ParserResult<TagKindPrimarySkill> => {
                              return ((
                                value: unknown,
                              ): ParserResult<{
                                discriminator: KindPrimarySkill;
                                id: bigint;
                                kind: KindPrimarySkill;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "discriminator")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                }
                                const parsed_discriminator = ((): ParserResult<KindPrimarySkill> => {
                                  return ((value: unknown): ParserResult<KindPrimarySkill> => {
                                    return ((value: unknown): ParserResult<"primary-skill"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "primary-skill":
                                          return { success: true, value: "primary-skill" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be enum, one of 'primary-skill'.` };
                                      }
                                    })(value);
                                  })(value["discriminator"]);
                                })();
                                if (!parsed_discriminator.success) {
                                  return { success: false, reason: parsed_discriminator.reason };
                                }
                                if (!hasProp(value, "id")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                }
                                const parsed_id = ((): ParserResult<bigint> => {
                                  return ((value: unknown): ParserResult<bigint> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: BigInt(value) };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/id]: '${value}' expected to be of type bigint or number.` };
                                  })(value["id"]);
                                })();
                                if (!parsed_id.success) {
                                  return { success: false, reason: parsed_id.reason };
                                }
                                if (!hasProp(value, "kind")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                }
                                const parsed_kind = ((): ParserResult<KindPrimarySkill> => {
                                  return ((value: unknown): ParserResult<KindPrimarySkill> => {
                                    return ((value: unknown): ParserResult<"primary-skill"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "primary-skill":
                                          return { success: true, value: "primary-skill" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindPrimarySkill]: '${value}' expected to be enum, one of 'primary-skill'.` };
                                      }
                                    })(value);
                                  })(value["kind"]);
                                })();
                                if (!parsed_kind.success) {
                                  return { success: false, reason: parsed_kind.reason };
                                }
                                return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                              })(value);
                            })(value["tagKind"]);
                          })();
                          if (!parsed_tagKind.success) {
                            return { success: false, reason: parsed_tagKind.reason };
                          }
                          if (!hasProp(value, "value")) {
                            return { success: false, reason: `[#/components/schemas/Tag/primary-skill/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                          }
                          const parsed_value = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/Tag/primary-skill/value]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["value"]);
                          })();
                          if (!parsed_value.success) {
                            return { success: false, reason: parsed_value.reason };
                          }
                          return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { discriminator: "primary-skill" as const, ...parsedVariant.value } };
                      }
                      case "skill": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          exclude: boolean;
                          score: number;
                          source: TagSourceType;
                          tagKind: TagKindSkill;
                          value: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/Tag/skill]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/Tag/skill]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "exclude")) {
                            return { success: false, reason: `[#/components/schemas/Tag/skill/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                          }
                          const parsed_exclude = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/Tag/skill/exclude]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["exclude"]);
                          })();
                          if (!parsed_exclude.success) {
                            return { success: false, reason: parsed_exclude.reason };
                          }
                          if (!hasProp(value, "score")) {
                            return { success: false, reason: `[#/components/schemas/Tag/skill/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                          }
                          const parsed_score = ((): ParserResult<number> => {
                            return ((value: unknown): ParserResult<number> => {
                              if (typeof value === "number") {
                                return { success: true, value: value };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: Number(value) };
                              }
                              return { success: false, reason: `[#/components/schemas/Tag/skill/score]: '${value}' expected to be of type number or bigint.` };
                            })(value["score"]);
                          })();
                          if (!parsed_score.success) {
                            return { success: false, reason: parsed_score.reason };
                          }
                          if (!hasProp(value, "source")) {
                            return { success: false, reason: `[#/components/schemas/Tag/skill/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                          }
                          const parsed_source = ((): ParserResult<TagSourceType> => {
                            return ((value: unknown): ParserResult<TagSourceType> => {
                              return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "USER":
                                    return { success: true, value: "USER" };
                                  case "AI":
                                    return { success: true, value: "AI" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                }
                              })(value);
                            })(value["source"]);
                          })();
                          if (!parsed_source.success) {
                            return { success: false, reason: parsed_source.reason };
                          }
                          if (!hasProp(value, "tagKind")) {
                            return { success: false, reason: `[#/components/schemas/Tag/skill/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                          }
                          const parsed_tagKind = ((): ParserResult<TagKindSkill> => {
                            return ((value: unknown): ParserResult<TagKindSkill> => {
                              return ((
                                value: unknown,
                              ): ParserResult<{
                                discriminator: KindSkill;
                                id: bigint;
                                kind: KindSkill;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/TagKindSkill]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/TagKindSkill]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "discriminator")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindSkill/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                }
                                const parsed_discriminator = ((): ParserResult<KindSkill> => {
                                  return ((value: unknown): ParserResult<KindSkill> => {
                                    return ((value: unknown): ParserResult<"skill"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "skill":
                                          return { success: true, value: "skill" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be enum, one of 'skill'.` };
                                      }
                                    })(value);
                                  })(value["discriminator"]);
                                })();
                                if (!parsed_discriminator.success) {
                                  return { success: false, reason: parsed_discriminator.reason };
                                }
                                if (!hasProp(value, "id")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindSkill/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                }
                                const parsed_id = ((): ParserResult<bigint> => {
                                  return ((value: unknown): ParserResult<bigint> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: BigInt(value) };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/TagKindSkill/id]: '${value}' expected to be of type bigint or number.` };
                                  })(value["id"]);
                                })();
                                if (!parsed_id.success) {
                                  return { success: false, reason: parsed_id.reason };
                                }
                                if (!hasProp(value, "kind")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindSkill/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                }
                                const parsed_kind = ((): ParserResult<KindSkill> => {
                                  return ((value: unknown): ParserResult<KindSkill> => {
                                    return ((value: unknown): ParserResult<"skill"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "skill":
                                          return { success: true, value: "skill" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be enum, one of 'skill'.` };
                                      }
                                    })(value);
                                  })(value["kind"]);
                                })();
                                if (!parsed_kind.success) {
                                  return { success: false, reason: parsed_kind.reason };
                                }
                                return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                              })(value);
                            })(value["tagKind"]);
                          })();
                          if (!parsed_tagKind.success) {
                            return { success: false, reason: parsed_tagKind.reason };
                          }
                          if (!hasProp(value, "value")) {
                            return { success: false, reason: `[#/components/schemas/Tag/skill/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                          }
                          const parsed_value = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/Tag/skill/value]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["value"]);
                          })();
                          if (!parsed_value.success) {
                            return { success: false, reason: parsed_value.reason };
                          }
                          return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { discriminator: "skill" as const, ...parsedVariant.value } };
                      }
                      case "key-quality": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          exclude: boolean;
                          score: number;
                          source: TagSourceType;
                          tagKind: TagKindKeyQuality;
                          value: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/Tag/key-quality]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/Tag/key-quality]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "exclude")) {
                            return { success: false, reason: `[#/components/schemas/Tag/key-quality/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                          }
                          const parsed_exclude = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/Tag/key-quality/exclude]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["exclude"]);
                          })();
                          if (!parsed_exclude.success) {
                            return { success: false, reason: parsed_exclude.reason };
                          }
                          if (!hasProp(value, "score")) {
                            return { success: false, reason: `[#/components/schemas/Tag/key-quality/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                          }
                          const parsed_score = ((): ParserResult<number> => {
                            return ((value: unknown): ParserResult<number> => {
                              if (typeof value === "number") {
                                return { success: true, value: value };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: Number(value) };
                              }
                              return { success: false, reason: `[#/components/schemas/Tag/key-quality/score]: '${value}' expected to be of type number or bigint.` };
                            })(value["score"]);
                          })();
                          if (!parsed_score.success) {
                            return { success: false, reason: parsed_score.reason };
                          }
                          if (!hasProp(value, "source")) {
                            return { success: false, reason: `[#/components/schemas/Tag/key-quality/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                          }
                          const parsed_source = ((): ParserResult<TagSourceType> => {
                            return ((value: unknown): ParserResult<TagSourceType> => {
                              return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "USER":
                                    return { success: true, value: "USER" };
                                  case "AI":
                                    return { success: true, value: "AI" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                }
                              })(value);
                            })(value["source"]);
                          })();
                          if (!parsed_source.success) {
                            return { success: false, reason: parsed_source.reason };
                          }
                          if (!hasProp(value, "tagKind")) {
                            return { success: false, reason: `[#/components/schemas/Tag/key-quality/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                          }
                          const parsed_tagKind = ((): ParserResult<TagKindKeyQuality> => {
                            return ((value: unknown): ParserResult<TagKindKeyQuality> => {
                              return ((
                                value: unknown,
                              ): ParserResult<{
                                discriminator: KindKeyQuality;
                                id: bigint;
                                kind: KindKeyQuality;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/TagKindKeyQuality]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/TagKindKeyQuality]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "discriminator")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                }
                                const parsed_discriminator = ((): ParserResult<KindKeyQuality> => {
                                  return ((value: unknown): ParserResult<KindKeyQuality> => {
                                    return ((value: unknown): ParserResult<"key-quality"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "key-quality":
                                          return { success: true, value: "key-quality" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be enum, one of 'key-quality'.` };
                                      }
                                    })(value);
                                  })(value["discriminator"]);
                                })();
                                if (!parsed_discriminator.success) {
                                  return { success: false, reason: parsed_discriminator.reason };
                                }
                                if (!hasProp(value, "id")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                }
                                const parsed_id = ((): ParserResult<bigint> => {
                                  return ((value: unknown): ParserResult<bigint> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: BigInt(value) };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/id]: '${value}' expected to be of type bigint or number.` };
                                  })(value["id"]);
                                })();
                                if (!parsed_id.success) {
                                  return { success: false, reason: parsed_id.reason };
                                }
                                if (!hasProp(value, "kind")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindKeyQuality/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                }
                                const parsed_kind = ((): ParserResult<KindKeyQuality> => {
                                  return ((value: unknown): ParserResult<KindKeyQuality> => {
                                    return ((value: unknown): ParserResult<"key-quality"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "key-quality":
                                          return { success: true, value: "key-quality" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be enum, one of 'key-quality'.` };
                                      }
                                    })(value);
                                  })(value["kind"]);
                                })();
                                if (!parsed_kind.success) {
                                  return { success: false, reason: parsed_kind.reason };
                                }
                                return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                              })(value);
                            })(value["tagKind"]);
                          })();
                          if (!parsed_tagKind.success) {
                            return { success: false, reason: parsed_tagKind.reason };
                          }
                          if (!hasProp(value, "value")) {
                            return { success: false, reason: `[#/components/schemas/Tag/key-quality/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                          }
                          const parsed_value = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/Tag/key-quality/value]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["value"]);
                          })();
                          if (!parsed_value.success) {
                            return { success: false, reason: parsed_value.reason };
                          }
                          return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { discriminator: "key-quality" as const, ...parsedVariant.value } };
                      }
                      case "classification": {
                        const parsedVariant = ((
                          value: unknown,
                        ): ParserResult<{
                          exclude: boolean;
                          score: number;
                          source: TagSourceType;
                          tagKind: TagKindClassification;
                          value: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/Tag/classification]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/Tag/classification]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "exclude")) {
                            return { success: false, reason: `[#/components/schemas/Tag/classification/exclude]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'exclude'.` };
                          }
                          const parsed_exclude = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/Tag/classification/exclude]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["exclude"]);
                          })();
                          if (!parsed_exclude.success) {
                            return { success: false, reason: parsed_exclude.reason };
                          }
                          if (!hasProp(value, "score")) {
                            return { success: false, reason: `[#/components/schemas/Tag/classification/score]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'score'.` };
                          }
                          const parsed_score = ((): ParserResult<number> => {
                            return ((value: unknown): ParserResult<number> => {
                              if (typeof value === "number") {
                                return { success: true, value: value };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: Number(value) };
                              }
                              return { success: false, reason: `[#/components/schemas/Tag/classification/score]: '${value}' expected to be of type number or bigint.` };
                            })(value["score"]);
                          })();
                          if (!parsed_score.success) {
                            return { success: false, reason: parsed_score.reason };
                          }
                          if (!hasProp(value, "source")) {
                            return { success: false, reason: `[#/components/schemas/Tag/classification/source]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'source'.` };
                          }
                          const parsed_source = ((): ParserResult<TagSourceType> => {
                            return ((value: unknown): ParserResult<TagSourceType> => {
                              return ((value: unknown): ParserResult<"USER" | "AI"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "USER":
                                    return { success: true, value: "USER" };
                                  case "AI":
                                    return { success: true, value: "AI" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/TagSourceType]: '${value}' expected to be enum, one of 'USER, AI'.` };
                                }
                              })(value);
                            })(value["source"]);
                          })();
                          if (!parsed_source.success) {
                            return { success: false, reason: parsed_source.reason };
                          }
                          if (!hasProp(value, "tagKind")) {
                            return { success: false, reason: `[#/components/schemas/Tag/classification/tagKind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'tagKind'.` };
                          }
                          const parsed_tagKind = ((): ParserResult<TagKindClassification> => {
                            return ((value: unknown): ParserResult<TagKindClassification> => {
                              return ((
                                value: unknown,
                              ): ParserResult<{
                                discriminator: KindClassification;
                                id: bigint;
                                kind: KindClassification;
                              }> => {
                                if (typeof value !== "object") {
                                  return { success: false, reason: `[#/components/schemas/TagKindClassification]: '${value}' expected to be of type 'object'.` };
                                }
                                if (value === null) {
                                  return { success: false, reason: `[#/components/schemas/TagKindClassification]: '${value}' expected to not be null.` };
                                }
                                if (!hasProp(value, "discriminator")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindClassification/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
                                }
                                const parsed_discriminator = ((): ParserResult<KindClassification> => {
                                  return ((value: unknown): ParserResult<KindClassification> => {
                                    return ((value: unknown): ParserResult<"classification"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "classification":
                                          return { success: true, value: "classification" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be enum, one of 'classification'.` };
                                      }
                                    })(value);
                                  })(value["discriminator"]);
                                })();
                                if (!parsed_discriminator.success) {
                                  return { success: false, reason: parsed_discriminator.reason };
                                }
                                if (!hasProp(value, "id")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindClassification/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
                                }
                                const parsed_id = ((): ParserResult<bigint> => {
                                  return ((value: unknown): ParserResult<bigint> => {
                                    if (typeof value === "number") {
                                      return { success: true, value: BigInt(value) };
                                    }
                                    if (typeof value === "bigint") {
                                      return { success: true, value: value };
                                    }
                                    return { success: false, reason: `[#/components/schemas/TagKindClassification/id]: '${value}' expected to be of type bigint or number.` };
                                  })(value["id"]);
                                })();
                                if (!parsed_id.success) {
                                  return { success: false, reason: parsed_id.reason };
                                }
                                if (!hasProp(value, "kind")) {
                                  return { success: false, reason: `[#/components/schemas/TagKindClassification/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
                                }
                                const parsed_kind = ((): ParserResult<KindClassification> => {
                                  return ((value: unknown): ParserResult<KindClassification> => {
                                    return ((value: unknown): ParserResult<"classification"> => {
                                      if (typeof value !== "string") {
                                        return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be of type string.` };
                                      }
                                      switch (value) {
                                        case "classification":
                                          return { success: true, value: "classification" };
                                        default:
                                          return { success: false, reason: `[#/components/schemas/KindClassification]: '${value}' expected to be enum, one of 'classification'.` };
                                      }
                                    })(value);
                                  })(value["kind"]);
                                })();
                                if (!parsed_kind.success) {
                                  return { success: false, reason: parsed_kind.reason };
                                }
                                return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
                              })(value);
                            })(value["tagKind"]);
                          })();
                          if (!parsed_tagKind.success) {
                            return { success: false, reason: parsed_tagKind.reason };
                          }
                          if (!hasProp(value, "value")) {
                            return { success: false, reason: `[#/components/schemas/Tag/classification/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
                          }
                          const parsed_value = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/Tag/classification/value]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["value"]);
                          })();
                          if (!parsed_value.success) {
                            return { success: false, reason: parsed_value.reason };
                          }
                          return { success: true, value: { exclude: parsed_exclude.value, score: parsed_score.value, source: parsed_source.value, tagKind: parsed_tagKind.value, value: parsed_value.value } };
                        })(value);
                        if (!parsedVariant.success) {
                          return { success: false, reason: parsedVariant.reason };
                        }
                        return { success: true, value: { discriminator: "classification" as const, ...parsedVariant.value } };
                      }
                      default:
                        return {
                          success: false,
                          reason: `[#/components/schemas/Tag]: '${discriminator}' expected to be one of 'dynamicString, dynamicBoolean, dynamicNumber, dynamicVoid, channel, primary-skill, skill, key-quality, classification'.`,
                        };
                    }
                  })(value);
                })(value);
              })(value["tag"]);
            })();
            if (!parsed_tag.success) {
              return { success: false, reason: parsed_tag.reason };
            }
            if (!hasProp(value, "title")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
            }
            const parsed_title = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/title]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["title"]);
            })();
            if (!parsed_title.success) {
              return { success: false, reason: parsed_title.reason };
            }
            if (!hasProp(value, "visibleLanguages")) {
              return { success: false, reason: `[#/components/schemas/ChannelMetadata/visibleLanguages]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'visibleLanguages'.` };
            }
            const parsed_visibleLanguages = ((): ParserResult<Language[]> => {
              return ((value: unknown): ParserResult<Language[]> => {
                if (!isArray(value)) {
                  return { success: false, reason: `[#/components/schemas/ChannelMetadata/visibleLanguages]: '${value}' expected to be an array.` };
                }
                const parsed = value.map((value: unknown): ParserResult<Language> => {
                  return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
                    if (typeof value !== "string") {
                      return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
                    }
                    switch (value) {
                      case "en":
                        return { success: true, value: "en" };
                      case "de":
                        return { success: true, value: "de" };
                      case "es":
                        return { success: true, value: "es" };
                      case "ru":
                        return { success: true, value: "ru" };
                      case "zh":
                        return { success: true, value: "zh" };
                      case "pt":
                        return { success: true, value: "pt" };
                      case "fr":
                        return { success: true, value: "fr" };
                      default:
                        return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
                    }
                  })(value);
                });
                if (parsed.find((value) => !value.success) !== undefined) {
                  return {
                    success: false,
                    reason: `[#/components/schemas/ChannelMetadata/visibleLanguages]: Reason(s): '${parsed
                      .filter((p) => !p.success)
                      .map((p) => p.reason)
                      .join(", ")}'.`,
                  };
                }
                return {
                  success: true,
                  value: parsed.map((entry) => {
                    assert(entry.success == true);
                    return entry.value;
                  }),
                };
              })(value["visibleLanguages"]);
            })();
            if (!parsed_visibleLanguages.success) {
              return { success: false, reason: parsed_visibleLanguages.reason };
            }
            return {
              success: true,
              value: {
                activationTime: parsed_activationTime.value,
                active: parsed_active.value,
                channelId: parsed_channelId.value,
                channelLocalization: parsed_channelLocalization.value,
                coverUri: parsed_coverUri.value,
                definition: parsed_definition.value,
                descriptionHtml: parsed_descriptionHtml.value,
                modificationTime: parsed_modificationTime.value,
                name: parsed_name.value,
                synonyms: parsed_synonyms.value,
                tag: parsed_tag.value,
                title: parsed_title.value,
                visibleLanguages: parsed_visibleLanguages.value,
              },
            };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ChannelMetadataArray/channelMetadata]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["channelMetadata"]);
    })();
    if (!parsed_channelMetadata.success) {
      return { success: false, reason: parsed_channelMetadata.reason };
    }
    return { success: true, value: { channelMetadata: parsed_channelMetadata.value } };
  })(parseJsonWithNumbersAsBigint(str));
}
